import React from 'react';
import { images } from '../assets/images';
import Advantages from '../components/Advantages';
import ContactUs from '../components/ContactUs';
import CTA from '../components/CTA';
import FeaturedSection from '../components/FeaturedSection';
import './Sonda.css';

function Sonda() {
  return (
    <div className="Sonda">
      <div className='Sonda_hero'>
        <div className='column-left'>
        {/* <h1 className='title'>The software&nbsp;suite<br className="full-width-breakpoint"/> for <strong>retail</strong> points&nbsp;of&nbsp;sale</h1> */}
        <h1 className='title'>The cryptocurrency exchange focused&nbsp;on <strong>retail&nbsp;and&nbsp;fiat</strong></h1>
        <p className='align-left'>Sonda is a software cryptocurrency exchange enabling users to seamlessly buy and sell cryptocurrencies using cash, or via cashless payment method, and purchase digital services at retail points of sale.</p>
        </div>
        <div className='column-right'>
        <img src={images.app_hand_token}/>
        </div>
      </div>
      <section className='function'>
        <div className='imgs'>
          <img src={images.cashback}/>
        </div>
        <div className='text'>
          <h2>Virtual currencies at physical stores</h2>
          <p>Sonda allows users to buy and sell cryptocurrencies using cash, or via cashless payment methods. Thanks to our direct-to-ATM technology, Sonda users can connect their app to ATMs using our proprietary tech, to easily buy and sell crypto with their own fiat currency.</p>
        </div>
      </section>
      <section className='function'>
        <div className='imgs'>
          <img src={images.cashback}/>
        </div>
        <div className='text'>
          <h2>Crypto on/off ramp at ATMs</h2>
          <p>Thanks to the Dashboard, vending operators can monitor both cash and cashless purchases, analyse machines’ performances, start marketing initiatives, and manage support requests.</p>
        </div>
      </section>
      <section className='function'>
        <div className='imgs'>
          <img src={images.cashback}/>
        </div>
        <div className='text'>
          <h2>Peer-to-peer transactions</h2>
          <p>Sonda facilitates peer-to-peer transactions and money remittance, thanks to ultra-low fees and secure exchange of tokens guaranteed by the blockchain infrastructure.</p>
        </div>
      </section>
      <CTA
      title='Let’s build together the fintech of tomorrow'
      subtitle='We are developing new fintech solutions to make payments seamlessly. Join us and start thinking about tomorrow.'
      button='Ask about Sonda'
      ></CTA>
      <Advantages
      title="Why Sonda?"
      img1={images.case}
      img2={images.case}
      img3={images.case}
      text1="Secure and reliable transactions"
      text2="Swap at low fees"
      text3="Users can spend their favourite tokens"
      ></Advantages>
      <ContactUs
      title="Contact us"
      subtitle="We are open to give you further details about BOXi"
      button="Leave a message"
      ></ContactUs>
    </div>
  );
}

export default Sonda;
